import instance from './axiosInstance'

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$axios', { value: instance })
  }
}